// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Entity } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormManageContract } from '../../forms/FormManageContract/FormManageContract';

// props
export interface DialogAddContractProps {
	entity?: Entity;
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddContract = ({
	entity,
	isOpen,
	onClose,
	onSuccess,
}: DialogAddContractProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('addContract'),
					form: 'form-manage-contract',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={{ children: entity ? entity.name : undefined }}
			title={{
				children: t('addContract'),
				variant: 'h3',
			}}>
			<FormManageContract
				entity={entity}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
